import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CustomCart } from '@cart/const';
import { CustomActiveCartService } from '@cart/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { CurrentProfile } from '@user/const';
import { BonusSystemFeatureAvailableService, CurrentProfileService } from '@user/feature';
import { Observable, Subscription, combineLatest, map } from 'rxjs';

@Component({
  selector: 'sd-checkout-order-summary',
  templateUrl: './checkout-order-summary.component.html',
  styleUrls: ['./checkout-order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorCheckoutOrderSummaryComponent implements OnInit, OnDestroy {
  cart$: Observable<CustomCart>;
  iconType = CUSTOM_ICON_TYPE;
  isBonusSystemEnabled$: Observable<boolean | undefined>;
  isLegalUser$: Observable<boolean>;
  currentProfile$: Observable<CurrentProfile>;
  bonusAssignedAmount$: Observable<string | undefined>;
  private subscription = new Subscription();

  constructor(
    private activeCartService: CustomActiveCartService,
    private currentProfileService: CurrentProfileService,
    private bonusSystemFeatureAvailableService: BonusSystemFeatureAvailableService,
  ) {}

  ngOnInit(): void {
    this.cart$ = this.activeCartService.getActive();
    this.currentProfile$ = this.currentProfileService.get();
    this.isBonusSystemEnabled$ = this.bonusSystemFeatureAvailableService.isFeatureAvailableForUser();
    this.bonusAssignedAmount$ = combineLatest([this.activeCartService.getActive(), this.isBonusSystemEnabled$]).pipe(
      map(([cart, isFeatureEnabled]) => {
        if (!isFeatureEnabled) {
          return undefined;
        }

        return cart.bonus?.assignedAmountInfo?.formattedValue;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
